<script>
import {affiliateTitularsService} from "../../Services/AffiliateTitularsService";
import {myMixins} from "../mixins/myMixins";

export default {
    name: "updateInfoBankAffiliate",
    mixins: [myMixins],
    props: {
        affiliate_id: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            form: {
                banco: '',
                cuenta: '',
                clabe: '',
                email: '',
                phone: '',
                rfc: ''
            }
        }
    },
    methods: {
        async updateAffiliate() {
            let resp = '';
            let respVal = this.valFormulariosV3('refundForm');
            if (respVal) {
                this.disableSubmitBtn(true);
                resp = await affiliateTitularsService.updateInfoBankAffiliate(this.affiliate_id, this.form);
                this.modificar = false;
                if (resp.process === 'updated_refund') {
                    this.showModal = false;
                    this.getAlert(resp.process);
                } else {
                    this.getAlert(resp.process);
                }
                this.disableSubmitBtn(false);
            }
        }
    },
    async mounted() {
        let infoBank = await affiliateTitularsService.getOne(this.affiliate_id);
        //console.log('infoBank- ', infoBank);
        this.form.banco = infoBank.banco;
        this.form.cuenta = infoBank.cuenta;
        this.form.clabe = infoBank.clabe;
        this.form.email = infoBank.reluser.email;
        this.form.phone = infoBank.phone;
        this.form.rfc = infoBank.rfc;

    },
}
</script>

<template>
    <div class="row">
        <div class="col-12 col-sm-12">
            <div class="cardAfiliado mb-4">
                <h3 class="p-4">Datos para Reembolso</h3>
                <div class="card-body pr-3 pl-3 pb-3">
                    <form id="refundForm" class="refundForm mb-4">
                        <div class="row justify-content-center">
                            <div class="col-12 col-sm-12">
                                <div class="alert alert-info" role="alert">
                                    Para poder hacer el reembolso necesitamos los siguientes datos, sin ellos la sección
                                    no se activara. Recuerda subir tu estado de cuenta en la sección de papelería.
                                </div>
                            </div>
                            <div class="col-12 col-sm-6">
                                <input type="text" v-model="form.banco" placeholder="Banco*"
                                       class="al-inputs scr-input required">
                            </div>
                            <div class="col-12 col-sm-6">
                                <input type="text" v-model="form.cuenta" placeholder="# de tarjeta (16 digitos)*"
                                       class="al-inputs scr-input">
                            </div>
                            <div class="col-12 col-sm-6">
                                <input type="text" maxlength="18" v-model="form.clabe" placeholder="Clabe*"
                                       class="al-inputs scr-input required">
                            </div>
                            <div class="col-12 col-sm-6">
                                <input type="text" v-model="form.email" placeholder="Email*"
                                       class="al-inputs scr-input required">
                            </div>
                            <div class="col-12 col-sm-6">
                                <input type="text" v-model="form.phone" placeholder="Teléfono*"
                                       class="al-inputs scr-input required">
                            </div>
                            <div class="col-12 col-sm-6">
                                <input type="text" v-model="form.rfc" placeholder="Rfc*"
                                       class="al-inputs scr-input required">
                            </div>
                            <div class="col-12 col-sm-4">
                                <button id="dyn-button" type="button" class="formSubmit" @click="updateAffiliate()">
                                    Actualizar
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
